const hopId = '__hop_id';

export const addHopIdToSessionStorage = (userId: number) => {
  sessionStorage.setItem(hopId, `${new Date().getTime()}_${userId}`);
};

export const addHopIdToHeader = (): Record<string, string> => {
  const tabHopId = window.sessionStorage.getItem(hopId);

  // eslint-disable-next-line @typescript-eslint/naming-convention
  return tabHopId == null ? {} : { 'X-Hop-Id': tabHopId };
};

export const getHopId = () => {
  return window.sessionStorage.getItem(hopId);
};

export const safelyParseJSON = (jsonString) => {
  try {
    const parsedData = JSON.parse(jsonString);

    return parsedData; // Return the parsed object if successful
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    return null; // Return null or a default value in case of error
  }
};
